import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import moment from "moment";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import RectangleLoader from "common-components/RectangleLoader";
import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { cleanDateFormat } from "utils/cleanDateFormat";
import { ENDPOINTS } from "utils/endpoints";
import { agentNewRequest } from "./actions";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { fetchPageContent } from "../DownloadAndDelete/actions";

// import { Radio } from "common-components/FormContent";
import { TitleLockup } from "@vds/type-lockups";
import { RadioButton } from "@vds/radio-buttons";
import { Body, Title } from "@vds/typography"
import CommonHeader from "common-components/Header";
import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";
import { media, isMobile } from "utils/style";
import {
  AlreadyDeleted,
  MaximumDownload,
  PendingDownload,
  PendingDelete
} from "./modals";

class AuthorizedAgentNewRequest extends Component {
  state = {
    showModal: false,
    modalToDisplay: "",
    pendingItem: {}
  };

  componentDidMount() {
    if (checkNestedObject(this.props.breadCrumbs, "landingPage")) {
      const { landingPage, customerHistory, informationRequest } = this.props.breadCrumbs;

      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/authorized-agent" },
        { label: customerHistory, path: "/privacy/secure/authorized-agent/customer" },
        { label: informationRequest, path: "/privacy/secure/authorized-agent/new-request" }
      ]);
    }

    if (checkNestedObject(this.props, "pageContent", "sc_pagetitle")) {
      this.props.setA11yContent("new request", this.props.pageContent.sc_pagetitle);
    }

    if (this.props.agentCustomerHistory && this.props.agentCustomerHistory.elementsData) {
      for (let item of this.props.agentCustomerHistory.elementsData) {
        const status = this.checkCustomerHistory(
          item.requestType,
          item.status,
          item.downloadAvailabilityDeadline
        );
        if (status && (status === "DOWNLOAD_IN_PROGRESS" || status === "DELETE_IN_PROGRESS" || status === "FILE_AVAILABLE")) {
          this.setState({ blockTransactionReason: status, pendingItem: item });
          break;
        }
      }
    }
    if (this.props.customerPendingRequest && this.props.customerPendingRequest.requestType) {
      const { requestType, downloadAvailabilityDeadline } = this.props.customerPendingRequest;

      const fileAvailable = downloadAvailabilityDeadline
        ? moment().isBefore(moment(downloadAvailabilityDeadline).add(1, "d"))
        : "";
      if (
        requestType === "DOWNLOAD_IN_PROGRESS" ||
        requestType === "DELETE_IN_PROGRESS" ||
        (requestType === "DOWNLOAD_FILE_AVAILABLE" && fileAvailable)
      ) {
        this.setState({ customerHasPendingRequest: true, blockTransactionReason: "" });
      }
    }
  }

  checkCustomerHistory = (requestType, status, downloadAvailabilityDeadline) => {
    if (
      (requestType === "DOWNLOAD" || requestType === "DOWNLOAD_AFFIDAVIT") &&
      (status === "COMPLETED" || status === "IN_PROGRESS")
    ) {
      if (status === "COMPLETED") {
        const isBefore = moment().isBefore(moment(downloadAvailabilityDeadline).add(1, "d"));
        const isAfter = moment().isAfter(moment(downloadAvailabilityDeadline).add(1, "d"));
        if (isBefore) {
          return "FILE_AVAILABLE";
        } else if (isAfter) {
          return "EXPIRED";
        }
      } else {
        return "DOWNLOAD_IN_PROGRESS";
      }
    } else if (requestType === "DELETE") {
      if (status === "IN_PROGRESS") {
        return "DELETE_IN_PROGRESS";
      }
    }
    else if (requestType === "CORRECT") {
      if (status === "IN_PROGRESS") {
        return "CORRECT_IN_PROGRESS";
      }
    }
    return status;
  };

  handleContinueClick = () => {
    const {
      agentSelectedFlow,
      agentCustomerHistory: { hasDeleted, noOfAffidavitDownloadRemaining }
    } = this.props;

    const conditionForBlockDelete = ((this.state.blockTransactionReason === "DELETE_IN_PROGRESS" ||
      this.state.customerHasPendingRequest) && agentSelectedFlow === "delete");

    const conditionForBlockDownload = ((this.state.blockTransactionReason === "DOWNLOAD_IN_PROGRESS" ||
      this.state.customerHasPendingRequest) && agentSelectedFlow === "download");
    if (conditionForBlockDelete) {
      this.setState({ showModal: true, modalToDisplay: "blockDelete" });
    } else if (conditionForBlockDownload) {
      this.setState({ showModal: true, modalToDisplay: "blockDownload" });
    }

    if (agentSelectedFlow === "delete") {
      if (hasDeleted === "Y") {
        return this.setState({ showModal: true, modalToDisplay: "delete" });
      }
    } else if (agentSelectedFlow === "download") {
      if (noOfAffidavitDownloadRemaining === 0) {
        return this.setState({ showModal: true, modalToDisplay: "downloadMax" });
      }
    } else if (agentSelectedFlow === "correct") {
      this.props.fetchPageContent(ENDPOINTS.FETCH_DOWNLOAD_PAGES).then(() => {
        return this.props.history.push({
          pathname: "multifactor-authentication-primer",
          state: {
            confirmAuth: true,
            nextRoute: "/privacy/secure/authorized-agent/correction",
            customerHistory: this.props.agentCustomerHistory,
            agentSelectedCustomer: this.props.agentSelectedCustomer
          }
        });
      });
      return;
    }

    if (!conditionForBlockDelete && !conditionForBlockDownload) {
      return this.props.history.push(`/privacy/secure/authorized-agent/${agentSelectedFlow}`);
    }
  };
  
  custPendingRequest= {
    "dateOfRequest": "",
    "requestType": "",
    "downloadAvailabilityDeadline": ""
  };

  renderModal = () => {
    const { showModal, modalToDisplay, pendingItem: { dateOfRequest: agentDateOfRequest } } = this.state;
    const { deleteDateOfRequest, nextRollOffDateAffidavitDownload } = this.props.agentCustomerHistory;

    const { agentCustomerHistory: { custRequestedBefore: customerPendingRequest } } = this.props;
    const { dateOfRequest: customerDateOfRequest } = customerPendingRequest ? customerPendingRequest : this.custPendingRequest ;

    const dateOfRequest = moment(cleanDateFormat(deleteDateOfRequest)).format("MMM D, YYYY");
    const nextAvailableDownloadDate = moment(new Date(nextRollOffDateAffidavitDownload)).format(
      "MMM D, YYYY"
    );

    const dateOfRequestForBlock = customerDateOfRequest || agentDateOfRequest;
    const date = dateOfRequestForBlock ? moment(cleanDateFormat(dateOfRequestForBlock)).format("MMM D, YYYY") : "";

    if (showModal) {
      if (modalToDisplay === "delete") {
        return (
          <AlreadyDeleted
            modalContent={this.props.delete_limit_reached}
            dateOfRequest={dateOfRequest}
            closeModal={() => this.setState({ showModal: false })}
          />
        );
      } else if (modalToDisplay === "downloadMax") {
        return (
          <MaximumDownload
            modalContent={this.props.download_limit_reached}
            closeModal={() => this.setState({ showModal: false })}
            nextAvailableDownloadDate={nextAvailableDownloadDate}
          />
        );
      } else if (modalToDisplay === "blockDownload") {
        return (
          <PendingDownload
            modalContent={this.props.download_pending_modal}
            dateOfRequest={date}
            closeModal={() => this.setState({ showModal: false })}
          />
        );
      } else if (modalToDisplay === "blockDelete") {
        return (
          <PendingDelete
            modalContent={this.props.delete_pending}
            dateOfRequest={date}
            closeModal={() => this.setState({ showModal: false })}
          />
        );
      }
    }
    return null;
  };

  render() {

    if (this.props.loading) {
      return <RectangleLoader id="formerLoader" />;
    }

    if (!checkNestedObject(this.props, "pageContent", "section_title")) {
      return <Redirect to="/privacy/secure/authorized-agent" />;
    }

    const { section_title, section_description, genericList, buttons } = this.props.pageContent;
    const {
      agentSelectedCustomer: { serviceType },
      ott_information_request
    } = this.props;
    const customerIsOTT =
      serviceType &&
      (serviceType.toLowerCase() === "ott" ||
        serviceType.toLowerCase() === "nico" ||
        serviceType.toLowerCase() === 'autoapp' ||
        serviceType.toLowerCase() === 'ip' ||
        serviceType.toLowerCase() === "vils");      

    return (
      <Container>
        {this.renderModal()}
        {customerIsOTT ? (
          <Fragment>
              {/* DPCMP - 3792, 3791 */}
            <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: convertStringToElements(ott_information_request.section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    children: <Div> {convertStringToElements(ott_information_request.section_description)} </Div>
                    }

               }}
            
            />
            {/* <Header>{ott_information_request.section_title}</Header> */}
            {/* <Div style={{ maxWidth: "596px" }}> */}
              {/* {convertStringToElements(ott_information_request.section_description)} */}
              <fieldset style={{ marginTop: "40px" }}>
              <Body size='medium' bold={true}>{ott_information_request.genericList[0].text}</Body>
              {ott_information_request.genericList[0].list.map(item =>  {
                  return (
                    <div style={{ margin: "24px 0 0 18px" }} key={item.jsonKey}>
                      <RadioButton
                        value={item.jsonKey}
                        children={<span style={{marginLeft:"-28px"}} >{item.jsonValue}</span>}
                        selected={this.props.agentSelectedFlow === item.jsonKey.toLowerCase()}
                        onChange={this.props.agentNewRequest}
                      />
                    </div>
                  )
                })}
              </fieldset>
              <Button
                role={this.state.modalToDisplay ? "button" : "link"}
                onClick={this.handleContinueClick}
                background={ott_information_request.buttons[0].type}
                style={{ marginTop: "30px" }}
              >
                {ott_information_request.buttons[0].text}
              </Button>
            {/* </Div> */}
          </Fragment>
        ) : (
          <Fragment>
            <TitleLockup 
              surface= 'light'
              textAlignment= 'left'
              viewport={isMobile ? "mobile": "desktop"}
              data={{
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: convertStringToElements(section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    children: <Div> {convertStringToElements(section_description)} </Div>
                    }

               }}
            
            
            />
            {/* <Header>{section_title}</Header> */}
            {/* <Div style={{ maxWidth: "596px" }}> */}
              {/* {convertStringToElements(section_description)} */}
              <fieldset style={{ marginTop: "40px" }}>
                <Body size='medium' bold={true}>{genericList[0].text}</Body>
                {genericList[0].list.map(item =>  {
                  return (
                    <div style={{ margin: "24px 0 0 18px" }} key={item.jsonKey}>
                      <RadioButton
                        children={<span style={{marginLeft:"-28px"}}>{item.jsonValue}</span>}
                        value={item.jsonKey}
                        selected={this.props.agentSelectedFlow === item.jsonKey.toLowerCase()}
                        onChange={this.props.agentNewRequest}
                      />
                    </div>
                  )
                })}
              </fieldset>
              <Button
                role={this.state.modalToDisplay ? "button" : "link"}
                onClick={this.handleContinueClick}
                background={buttons[0].type}
                style={{ marginTop: "48px" }}
              >
                {buttons[0].text}
              </Button>
            {/* </Div> */}
          </Fragment>
        )}
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent: {
    information_request: pageContent,
    delete_limit_reached,
    download_limit_reached,
    ott_information_request,
    breadCrumbs,
    download_pending_modal,
    delete_pending
  },
  requestHistory,
  agentSelectedFlow,
  agentCustomerHistory,
  agentSelectedCustomer,
  loadingAndErrorState: { loading }
}) => ({
  pageContent,
  requestHistory,
  agentSelectedFlow,
  agentCustomerHistory,
  delete_limit_reached,
  download_limit_reached,
  ott_information_request,
  agentSelectedCustomer,
  breadCrumbs,
  loading,
  download_pending_modal,
  delete_pending
});

export default connect(
  mapStateToProps,
  { setA11yContent, setBreadcrumbList, agentNewRequest, fetchPageContent }
)(AuthorizedAgentNewRequest);

const Div = styled.div`
  max-width: 596px;
  p {
    padding: 10px 0;
  }

  ul {
    list-style: disc inside;
  }
  li {
    margin: 18px 0;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  }
`;

const Legend = styled.legend`
font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 20px;
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
    margin: 0;
    padding: 32px 16px ;
  `}
`;

const Header = styled(CommonHeader)`
  max-width: 598px;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 32px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-weight: 300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-weight: 300;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;
